// extracted by mini-css-extract-plugin
module.exports = {"container":"Rating_container_34f8c","wrapper":"Rating_wrapper_2kfWJ","star_overlay":"Rating_star_overlay_UI8nD"};